const Mixpanel = require("../../core/util/Mixpanel");

/**
 * Mixpanel event names (Mixpanel.js prefixes with `BA `):
 *
 * - **View Summary** — Used for every “surface shown” impression below, not only the
 *   post-lesson summary screen. Always segment by **`nav_surface`** (e.g. `lesson_summary`,
 *   `trophy_solution`, `hallway_celebration`, `library_book`) so dashboards stay correct.
 *   Optional third argument may include **`stars_obtained`** (number) when known, and for
 *   lesson summary **`primary_cta`** / **`secondary_cta`** (string slugs for the left and
 *   right nav buttons shown on that surface).
 * - **Summary Lesson Nav Click** — Primary/secondary nav taps on those flows; also uses
 *   **`nav_surface`** plus **`nav_choice`**. Optional fourth argument may include
 *   **`stars_obtained`** (number) for the lesson result when known.
 */

/** Where lesson-style nav analytics apply (Mixpanel `nav_surface`). */
const NAV_SURFACE = {
	LESSON_SUMMARY: "lesson_summary",
	TROPHY_SOLUTION: "trophy_solution",
	HALLWAY_CELEBRATION: "hallway_celebration",
	LIBRARY_BOOK: "library_book",
};

const SUMMARY_LESSON_NAV_CHOICES = new Set([
	"next_lesson",
	"back_to_path",
	"beast_lesson",
	"trophy_problem",
	"homework_completed_continue",
]);

/** @see module comment — event is shared across surfaces; use `nav_surface` in analysis. */
function trackViewSummarySurface(navSurface, user, mixpanelExtras) {
	if (!user) {
		return;
	}
	Mixpanel.track("View Summary", {
		nav_surface: navSurface,
		...(mixpanelExtras || {}),
	});
}

function trackSummaryLessonNavClick(
	navSurface,
	navChoice,
	user,
	mixpanelExtras
) {
	if (!user || !SUMMARY_LESSON_NAV_CHOICES.has(navChoice)) {
		return;
	}
	Mixpanel.track("Summary Lesson Nav Click", {
		nav_surface: navSurface,
		nav_choice: navChoice,
		...(mixpanelExtras || {}),
	});
}

module.exports = {
	NAV_SURFACE,
	SUMMARY_LESSON_NAV_CHOICES,
	trackViewSummarySurface,
	trackSummaryLessonNavClick,
};
